import React, { useState } from 'react'
import headers from "./header.json"
import { CustomClientNameComponent, CustomRaisedByComponent, CustomStatusComponent, ActionComponent, CustomDateComponent, CustomIDComponent } from './CusttomFields';
import { AGGridTable, Button, Chip, Drawer } from '../../../../components/common';
import { SupportTicketDetails } from './Details';
import { SelectClients } from './SelectClients';
import { CloseRoundedIcon, FilterIcon } from '../../../../theme/icons';
import { NormalPopover } from '../../../../components/common/PopOver/PopOver2';
import { useQuery } from '@apollo/client';
import { PERMISSION_WISE_ALL_CLIENTS } from '../../../../grapghQl/queries/clients';

export const FreshDeskTable = ({ gridOptions = {}, handleClickFilter = () => null, params = {},
    onSelectFilterByClient = () => null, filterBy = "",
    activeQuery = "", searchByStatus = () => null }) => {
    const [sideDrawer, setSideDrawer] = useState({
        open: false,
        setOpen: () => false,
        children: <></>,
        maxWidth: ' sm:max-w-[80vw] md:max-w-[75vw] lg:max-w-[35vw]'
    });

    const { data: { supportClientList = [] } = {}, loading: clientLoader } = useQuery(PERMISSION_WISE_ALL_CLIENTS, {
        fetchPolicy: 'cache',
    });

    const handleCloseDrawer = () => setSideDrawer({ ...sideDrawer, open: false })

    const handleViewTicket = (ticket) => setSideDrawer({
        ...sideDrawer, open: true,
        children: <SupportTicketDetails {...ticket} handleCloseDrawer={handleCloseDrawer} />, setOpen: () => handleCloseDrawer()
    })

    const cellRendererParams = {
        actions: { handleViewTicket: handleViewTicket, }
    }

    const cellRenderers = {
        id: CustomIDComponent,
        raised_by: CustomRaisedByComponent,
        name: CustomClientNameComponent,
        status: CustomStatusComponent,
        actions: ActionComponent,
        created_at: CustomDateComponent
    };

    const getDataHeaders = () => {
        const newheaders = [...headers] || []
        return newheaders.map(header => {
            header.cellRenderer = cellRenderers[header.field];
            header.cellRendererParams = cellRendererParams[header.field]
            return header;
        });
    }


    const filterParams = {
        status: [
            { name: 'Open', action: () => searchByStatus('2'), checked: activeQuery === '2', value: '2' },
            { name: 'On Hold', action: () => searchByStatus('8'), checked: activeQuery === '8', value: '8' },
            { name: 'Closed', action: () => searchByStatus('5'), checked: activeQuery === '5', value: '5' },
            { name: 'Resolved', action: () => searchByStatus('4'), checked: activeQuery === '4', value: '4' },
            { name: 'Pending', action: () => searchByStatus('3'), checked: activeQuery === '3', value: '3' },
            { name: 'RESET', action: () => searchByStatus(null), checked: false },
        ]
    }

    const FilterButton = () => {
        const [popover, setPopover] = useState(false);
        const handleOpenPopover = () => {
            setPopover(!popover)
        };

        const FilterComponent = () => {
            return (
                <div className='p-4 rounded-md w-[20rem] bg-white'>
                    <SelectClients clientLoader={clientLoader} supportClientList={supportClientList}
                        onSelectFilterByClient={onSelectFilterByClient} filterParams={filterParams} params={params}
                        handleClickFilter={handleClickFilter} value={filterBy} />
                </div>
            )
        }

        const selectedClient = () => {
            const url = params?.request?.filterModel?.search?.filter;
            const { name = "" } = (supportClientList?.length && supportClientList?.find((item) => item?.url === url)) || {}
            return name || ""
        }

        const handleCloseFilter = () => onSelectFilterByClient({ url: null });

        return (
            <div className='relative flex items-center gap-3'>
                {selectedClient() && <div>
                    <Chip variant="chip-teal" icon={<CloseRoundedIcon onClick={handleCloseFilter} className={"w-4 h-4 cursor-pointer"} />} className="flex items-center gap-1" text={selectedClient()} />
                </div>}
                <NormalPopover handleOpenPopover={handleOpenPopover} open={popover} className={"absolute inset-0 z-[999] left-[-18rem] right-5 top-5"}
                    content={<FilterComponent />} >
                    <Button text="" title="Filter" onClick={handleOpenPopover} className={`${popover ? "bg-primary-400 hover:bg-primary-300" : " hover:bg-primary-50"} p-2 h-fit w-fit  rounded-full`}
                        variant="secondary" icon={<FilterIcon className={`w-4 h-4 ${popover ? "stroke-white" : ""}`} />} />
                </NormalPopover>
            </div>
        )
    }

    return (
        <div>
            <Drawer {...sideDrawer} />
            <AGGridTable
                filterParams={filterParams}
                gridOptions={gridOptions}
                headers={getDataHeaders()}
                customComponentRight={
                    <FilterButton />
                }
                sidebar={false}
                search={false} />
        </div>
    )
}